import React from 'react'
import { Container, MessageWrapper } from './styled' 

const SearchInput = ({ inputValue, onHandleChange, isLoading, list, setLocation }) => {

  return (
    <Container>
      <div className="input-wrap"> 
          <svg width="17.76" height="17.76" viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd">
              <path d="M0 0H24V24H0z"/>
              <g stroke="#222222" strokeWidth="1.5" transform="translate(2 2)">
                <circle cx="8" cy="8" r="8"/>
                <path strokeLinecap="round" d="M15 14L19.95 18.95"/>
              </g>
            </g>
          </svg>
        <input 
          placeholder={ '예) 서초동, 삼청동, 방이동' } 
          value={inputValue}
          onChange={e => onHandleChange(e)}
        />
      </div>
      <div style={{ overflowY: 'auto', height: '70%' }}>
        {isLoading ? (
        <MessageWrapper>검색중</MessageWrapper>
        ) : list.length > 0 ?
          list.map((value, index) => (
            <div className='listItem' 
              onClick={setLocation.bind(null,value)} 
              key={index}
            >
              {value?.fullName}
            </div>
            )
          ) : inputValue ? (
            <MessageWrapper>검색결과가 없습니다</MessageWrapper>
            ) : (
            <MessageWrapper>주소를 검색해주세요</MessageWrapper> 
            )
        }
      </div>
    </Container>
 )
}

export default SearchInput;